import { AxiosResponse } from 'axios'
import { ReportsEndpoints } from '../reportsEndpoints'
import { requests } from '@/libs/axios/axios'

const generateReport = async (id: string): Promise<AxiosResponse> => {
  return requests.post(`${ReportsEndpoints.GENERATE_REPORT}`, { id }, { headers: { Accept: 'application/pdf' } })
}

export default generateReport
